import React from "react";
import ColumnManager from "./ColumnManager";
import { cn } from "../../../lib/utils";

/**
 * Slim options bar for tables that have no Vpagination toolbar of their own.
 * It sits directly above the table (instead of floating over it) and hosts the
 * manage-columns control on the right, matching where Vpagination renders it.
 *
 * Purely presentational - column state stays owned by the caller's existing
 * useColumnPreferences() call and is passed straight through to ColumnManager.
 *
 * @param {Array} columns - allColumns from useColumnPreferences
 * @param {function} onToggle - toggleVisibility handler
 * @param {function} onReorder - reorder handler
 * @param {function} onReset - resetToDefault handler
 * @param {string} className - extra classes for the bar
 * @param {React.ReactNode} children - optional filter controls, rendered on the left
 */
const TableToolbar = ({ columns, onToggle, onReorder, onReset, className, children }) => {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-between gap-2 border-b px-3 py-2",
        className
      )}
    >
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      <ColumnManager
        columns={columns}
        onToggle={onToggle}
        onReorder={onReorder}
        onReset={onReset}
      />
    </div>
  );
};

export default TableToolbar;
